'use strict';

/**
 * Converts the given value to a string.
 *
 * @param prop - The value to convert to a string.
 * @returns The string representation of the value, or an empty string if the value is falsy.
 *
 * @todo This isn't a very useful function. It's just a wrapper around `toString()`.
 * Consider giving it more functionality or removing it.
 */ function toString(prop) {
    return prop ? prop.toString() : '';
}

module.exports = toString;
